module.exports = require("./es-EC.js");